// @ts-ignore
 
import request from "src/lib/axios";

/** 个人信息查询授权书预览 GET /api/v1/contract/background-check-authorization-book/preview */
export async function ContractControllerPreviewBackgroundCheckAuthorizationBookV1(options?: {
  [key: string]: any;
}) {
  return request<any>(
    "/api/v1/contract/background-check-authorization-book/preview",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}

/** 查看背调结果 GET /api/v1/contract/background-check-result */
export async function ContractControllerPreviewBackgroundCheckResultV1(options?: {
  [key: string]: any;
}) {
  return request<any>("/api/v1/contract/background-check-result", {
    method: "GET",
    ...(options || {}),
  });
}

/** 短租租赁合同预览 GET /api/v1/contract/installment-rental-contract/preview */
export async function ContractControllerPreviewInstallmentRentalContractV1(options?: {
  [key: string]: any;
}) {
  return request<any>("/api/v1/contract/installment-rental-contract/preview", {
    method: "GET",
    ...(options || {}),
  });
}

/** 分期买卖合同预览 GET /api/v1/contract/rent-to-buy-contract/preview */
export async function ContractControllerPreviewRentToBuyContractV1(options?: {
  [key: string]: any;
}) {
  return request<any>("/api/v1/contract/rent-to-buy-contract/preview", {
    method: "GET",
    ...(options || {}),
  });
}
